import type { Locale } from '../enums/localeEnum'

class InputValidation {
    localePattern(locale: Locale, validation: string ) {
        const patterns = [
            {
                type: 'phone',
                locales: [
                    { locale: 'cs', pattern: "^\\s*(\\d\\s*){9}$" },
                    { locale: 'sk', pattern: "^\\s*(\\d\\s*){9,10}$"},
                    { locale: 'pl', pattern: "^\\s*(\\d\\s*){9}$"},
                    { locale: 'ro', pattern: "^\\s*(\\d\\s*){9,10}$"},
                    { locale: 'hu', pattern: "^\\s*(\\d\\s*){9}$"},
                    { locale: 'de', pattern: "^\\s*(\\d\\s*){9,13}$"},
                    { locale: 'at', pattern: "^\\s*(\\d\\s*){9,13}$"}
                ]
            },
            {
                type: 'psc',
                locales: [
                    { locale: 'cs', pattern: "^\\s*(\\d\\s*){5}$"},
                    { locale: 'sk', pattern: "^\\s*(\\d\\s*){5}$"},
                    { locale: 'pl', pattern: "^\\d{2}-\\d{3}$"},
                    { locale: 'ro', pattern: "^\\s*(\\d\\s*){6}$"},
                    { locale: 'hu', pattern: "^\\s*(\\d\\s*){4}$"},
                    { locale: 'de', pattern: "^\\s*(\\d\\s*){5}$"},
                    { locale: 'at', pattern: "^\\s*(\\d\\s*){4}$"}
                ]
            },
            {
                type: 'ico',
                locales: [
                    { locale: 'cs', pattern: "^\\s*\\d{8}\\s*$" }
                ]
            },
            {
                type: 'dic',
                locales: [
                    { locale: 'cs', pattern: "^[A-Za-z]{2,3}[A-Za-z0-9]{2,12}$" },
                    { locale: 'sk', pattern: "^[A-Z]{2,3}\\d{10}$", }
                ]
            }
        ];

        return patterns.find((item) => item.type === validation)?.locales.find((localeItem) => localeItem.locale === locale)?.pattern || undefined
    }

    pattern(locale: Locale, validation: string) {
        switch (validation) {
            case 'addressNote': {
                return '^[\\p{L}\\p{N}]+$'
            }
            case 'email': {
              return '^[\\w\\-\\.\\+]+@([\\w\\-]+\\.)+[\\w\\-]{2,30}$'
            }
            case 'ico': {
              return this.localePattern(locale, 'ico')
            }
            case 'dic': {
                return this.localePattern(locale, 'dic')
            }
            case 'street': {
                return '^(?=.*\\d)(?=.*\\s)(?=.*[a-zA-Z]).+$'
            }
            case 'psc': {
                return this.localePattern(locale, 'psc')
            }
            case 'phone': {
                return this.localePattern(locale, 'phone')
            }
            case 'variableSymbol': {
                return '^\\d{10}$'
            }
            case 'password': {
                return '^.{8,}$'
            }
            case 'customerNr': {
                return '^\\d{6,10}$'
            }
            default: {
              return ''
            }
        }
    }
}

export default new InputValidation()
